export enum ProjectCategoryEnum {
  'payment' = 'payment',
  'automation' = 'automation'
}
